import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const EditIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.36887 4.26258H5.38833C4.06929 4.26258 3 5.33184 3 6.65084V14.6117C3 15.9307 4.06929 17 5.38833 17H13.3494C14.6685 17 15.7377 15.9307 15.7377 14.6117L15.7377 10.6313M6.98055 13.0195L9.87705 12.4359C10.0308 12.4049 10.172 12.3292 10.2829 12.2183L16.767 5.73081C17.0779 5.41978 17.0776 4.9156 16.7665 4.60482L15.3929 3.23285C15.0819 2.9222 14.578 2.92241 14.2672 3.23332L7.78247 9.72144C7.6718 9.83217 7.59623 9.97306 7.56522 10.1265L6.98055 13.0195Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

EditIcon.displayName = 'CloseIconCircle';
